import { render, staticRenderFns } from "./RsaGestioneCentroDiurnoAssentiComponent.vue?vue&type=template&id=5a96cd0e"
import script from "./RsaGestioneCentroDiurnoAssentiComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCentroDiurnoAssentiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports